import {
  FieldWrapper,
  Input,
  Label,
  MaskedInput,
  Textarea,
} from '@commenda/kakashi';
import {
  CredentialBlockType,
  ICredentialBlock,
} from '@commenda/types/src/credential/types';

export const CredentialBlock = ({
  blockName,
  blockType,
  onChange,
  value,
}: {
  blockName: string;
  blockType: CredentialBlockType;
  value: string;
  onChange: (value: string) => void;
}) => {
  return (
    <FieldWrapper _className="w-full">
      <Label>{blockName}</Label>
      {blockType === CredentialBlockType.PlainText ? (
        <Input
          type="text"
          placeholder={blockName}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <MaskedInput
          hideIcon
          type="password"
          placeholder={blockName}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </FieldWrapper>
  );
};

const CredentialBlockFormFields = ({
  supportedCredentialBlocks,
  setSupportedCredentialBlocks,
  notes,
  setNotes,
}: {
  supportedCredentialBlocks: ICredentialBlock[];
  setSupportedCredentialBlocks: (
    supportedCredentialBlocks: ICredentialBlock[]
  ) => void;
  notes: string;
  setNotes: (notes: string) => void;
}) => {
  return (
    <div className="flex flex-col gap-4xl">
      <div className="flex flex-col gap-6xl">
        <div className="flex max-w-[1120px] gap-6xl">
          {supportedCredentialBlocks
            .filter((block) => !block.isCustomBlock)
            .map((supportedCredentialBlock) => (
              <CredentialBlock
                key={supportedCredentialBlock.key}
                blockName={supportedCredentialBlock.key}
                blockType={supportedCredentialBlock.type}
                value={
                  supportedCredentialBlocks.find(
                    (block) => block.key === supportedCredentialBlock.key
                  )?.value
                }
                onChange={(value) => {
                  setSupportedCredentialBlocks(
                    supportedCredentialBlocks.map((block) =>
                      block.key === supportedCredentialBlock.key
                        ? { ...block, value }
                        : block
                    )
                  );
                }}
              />
            ))}
        </div>
        <FieldWrapper>
          <Label htmlFor="notes">Notes (optional)</Label>
          <Textarea
            placeholder="Any additional notes about this credential"
            value={notes}
            onChange={(e) => {
              setNotes(e.target.value);
            }}
          />
        </FieldWrapper>
      </div>
    </div>
  );
};

export default CredentialBlockFormFields;
